import { render, staticRenderFns } from "./ProgramContacts.vue?vue&type=template&id=00ae4b7c&"
import script from "./ProgramContacts.vue?vue&type=script&lang=js&"
export * from "./ProgramContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports